import React, { useEffect, useState } from 'react';
import Navbar from '../../components/Navbar';
import '../../components/Navbar.css';
import AdminSidebar from '../../components/AdminSidebar';
import { getToken } from '../../utils/auth';
import { useParams, useNavigate } from 'react-router-dom';

function CommitteeEdit() {
  const { acctNum } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [candidates, setCandidates] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const token = getToken();
      const res = await fetch('/api/committees/' + acctNum, { headers: { 'x-auth-token': token } });
      if (res.ok) {
        const d = await res.json();
        setData(d);
      }
      setLoading(false);
    };
    fetchData();
  }, [acctNum]);

  useEffect(() => {
    // Fetch candidate(s) referencing this committee's acctNum
    const fetchCandidates = async () => {
      try {
        const res = await fetch('/api/candidates/byAccount/' + acctNum);
        if (res.ok) {
          const list = await res.json();
          setCandidates(list);
        }
      } catch (err) {
        console.error('fetchCandidates error', err);
      }
    };
    fetchCandidates();
  }, [acctNum]);

  if (loading) return <div>Loading...</div>;
  if (!data) return <div>Committee not found</div>;

  return (
    <div style={{ background: '#fff', minHeight: '100vh' }}>
      <Navbar />
  <div style={{ display: 'flex', maxWidth: '1200px', margin: '8px auto' }}>
        <AdminSidebar />
        <main style={{ flex: 1, padding: 12 }}>
          <h2>Edit Committee {acctNum}</h2>
          <pre style={{ whiteSpace: 'pre-wrap' }}>{JSON.stringify(data, null, 2)}</pre>

          <section style={{ marginTop: 16 }}>
            <h3>Related Candidates</h3>
            {candidates.length === 0 && <div>No candidates linked to this committee.</div>}
            {candidates.map(c => (
              <div key={c._id} style={{ padding: 8, border: '1px solid #eee', marginBottom: 8 }}>
                <div><strong>{c.NameFirst} {c.NameLast} (Acct {c.AcctNum})</strong></div>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 8 }}>
                  <label style={{ minWidth: 80 }}>VoterID</label>
                  <input
                    type="text"
                    value={c.VoterID || ''}
                    onChange={e => setCandidates(prev => prev.map(p => p._id === c._id ? { ...p, VoterID: e.target.value } : p))}
                    style={{ width: 220 }}
                  />
                  <button
                    onClick={async () => {
                      const token = getToken();
                      const payload = { VoterID: c.VoterID };
                      setSaving(true);
                      try {
                        const res = await fetch('/api/admin/candidates/' + c.AcctNum, {
                          method: 'PUT',
                          headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
                          body: JSON.stringify(payload)
                        });
                        if (!res.ok) {
                          const err = await res.json().catch(() => ({}));
                          throw new Error(err.msg || err.error || 'Save failed');
                        }
                        const updated = await res.json();
                        // update local state
                        setCandidates(prev => prev.map(p => p._id === c._id ? updated : p));
                        alert('Saved');
                      } catch (err) {
                        alert('Save error: ' + err.message);
                      } finally {
                        setSaving(false);
                      }
                    }}
                    disabled={saving}
                  >Save</button>
                </div>
              </div>
            ))}
          </section>

          <button onClick={() => navigate(-1)} style={{ marginTop: 12 }}>Back</button>
        </main>
      </div>
    </div>
  );
}

export default CommitteeEdit;
